// const CURRENT_VERSION = 30 // prev.: 29, cordova: 47

const CURRENT_VERSION =
  process.env?.VUE_APP_VERSION
    ? !process.env?.CORDOVA_PLATFORM
      ? Number(process.env.VUE_APP_VERSION.split('.')[2])
      : Number(process.env.VUE_APP_VERSION.split('.')[2]) + 30
    : 100

const TEST_DOMAIN = 'https://api.foglaljpalyat.hu:9007'
//const TEST_DOMAIN = 'https://localhost:9006'
const DEMO_DOMAIN = 'https://api.foglaljpalyat.hu:39006'
const LIVE_DOMAIN = 'https://api.foglaljpalyat.hu:29006'
const FOGLALAS_LIVE_DOMAIN = 'https://api.foglalas.coimbraits.hu:29007'
const FOGLALAS_TEST_DOMAIN = 'https://api.foglalas.coimbraits.hu:9006'
/*const FOGLALAS_LIVE_DOMAIN = 'https://api.foglaljpalyat.hu:29007'
const FOGLALAS_TEST_DOMAIN = 'https://api.foglaljpalyat.hu:9007'*/

let SERVER_DOMAIN = TEST_DOMAIN

if (process.env?.VUE_APP_TYPE === 'DEMO')
  SERVER_DOMAIN = DEMO_DOMAIN
else if (process.env?.VUE_APP_TYPE === 'LIVE')
  SERVER_DOMAIN = LIVE_DOMAIN
else if (process.env?.VUE_APP_TYPE === 'FOGLALAS_LIVE')
  SERVER_DOMAIN = FOGLALAS_LIVE_DOMAIN
else if (process.env?.VUE_APP_TYPE === 'FOGLALAS_TEST')
  SERVER_DOMAIN = FOGLALAS_TEST_DOMAIN

// eslint-disable-next-line no-prototype-builtins
const IS_CORDOVA_APP = process.env.hasOwnProperty('CORDOVA_PLATFORM')

const GOOGLE_LOGIN_URL = SERVER_DOMAIN + '/api/auth/google'
const FACEBOOK_LOGIN_URL = SERVER_DOMAIN + '/api/auth/facebook'

const API_KEY = 'ZGFzanNha2RqbGFzamRrYWpza2xqc2RrbGFzamRqYXNrbGRqYXNrbGpka2xhc2pka2xhc2prbA=='

export default {
  SERVER_DOMAIN: SERVER_DOMAIN,
  GOOGLE_LOGIN_URL: GOOGLE_LOGIN_URL,
  FACEBOOK_LOGIN_URL: FACEBOOK_LOGIN_URL,
  CURRENT_VERSION: CURRENT_VERSION,
  API_KEY: API_KEY,
  IS_CORDOVA_APP: IS_CORDOVA_APP,
  ENV: process.env?.VUE_APP_TYPE || 'TEST',
}
